export default {
    firstStepData: {
        data: {
//            "crashLink": true,
//            "description": "Your token has expired.",
            'block_x_days_to_meetings': 0,
            arrBlockedDate: {
                '2021-05-01': [], '2021-05-02': [], '2021-05-03': {'10:30': true, '11:45': true }, '2021-05-04': [], '2021-05-07': [],
                '2021-05-08': {'09:00': true}, '2021-05-09': [], '2021-05-10': {'10:00': true}, '2021-05-11': [],
                '2021-05-14': [], '2021-05-15': [], '2021-05-16': [], '2021-05-17': {'10:00': true, '13:45': true},
                '2021-05-18': [], '2021-05-21': [], '2021-05-22': {'04:15': true, '06:45': true}, '2021-05-23': [],
                '2021-05-24': [], '2021-05-25': {'04:15': true, '05:30': true, '06:45': true, '08:00': true},
                '2021-05-28': [], '2021-05-29': [], '2021-05-30': [],  '2021-05-31': [],
            },
            'breakDuration': 15,
            'descriptionPage': "Welcome to my scheduling page. Please follow the instruction to add on event to my calendar",
            'firstName': "Joomla",
            'lastName': "Wxw",
            'meetingDuration': 45,
//            'timeZone':-5,
            'timeZone': +3,
            'titlePage': "Joomla Wxw",
//            'faviconPath': "/themes/default/images/favicon.ico?v=7iBUlCA7n-g8SA7wtIEZ9A?v=7iBUlCA7n-g8SA7wtIEZ9A675605896",
            'faviconPath': "/assets/test/favicon.ico",
            'pageName': "Joomla Wxw",
            'workHours': {
                'sunday': null,
                'monday': null,
                'tuesday': {'from': 0, 'to': 23},
                'wednesday': {'from': 0, 'to': 0},
                'thursday': {'from': 7, 'to': 0},
                'friday': null,
                'saturday': null,
            }
        }

    },
    calendar_data: {
        data: {
            '2021-02-01': {'10:15': true, '14:00': true},
            '2021-02-07': {'14:00': true, '15:15': true},
            '2021-02-08': {'10:15': true, '14:00': true, '15:15': true},
            '2021-02-14': {'11:30': true, },
            '2021-02-15': {'11:30': true, '12:45': true, '16:30': true},
            '2021-02-21': {'14:00': true, '15:15': true},
            '2021-02-22': {'09:00': true},
            '2021-02-28': {'16:30': true},
            '2021-02-29': {'14:00': true},
            '2021-02-04': [], '2021-02-05': [], '2021-02-11': [], '2021-02-12': [], '2021-02-18': [], '2021-02-19': [],
            '2021-02-25': [], '2021-02-26': [],
        }
    }
}
